import {
  Button,
  Col,
  Descriptions,
  Form,
  Input,
  Row,
  Tooltip,
  Typography,
} from "antd";
import { useEffect, useState } from "react";

import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";

import Loading from "react-loading-bar";
import "react-loading-bar/dist/index.css";
import { customFilter, toConvertDate } from "../../../Utils/Utils";
import { toGetList, toPrintStock } from "../Api";
import printJS from "print-js";

const ListTransfert = ({ AppStore, ...props }) => {
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [show, setShow] = useState(true);
  const [orders, setOrders] = useState([]);
  const [ordersAll, setOrdersAll] = useState([]);
  const [article, setArticle] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    AppStore.setFirst(1);
    AppStore.setSecond(29);
    setLoading(true);
    getData();
  }, []);

  const getData = () => {
    toGetList().then((res) => {
      setOrders(res);
      setOrdersAll(res);
      setShow(false);
    });
  };

  const onSearch = (e) => {
    setSearchValue(e.target.value);
    const updatedList = customFilter(e.target.value, ordersAll, [
      "createdBy",
      "ref",
      "empSource",
      "empDest",
      "name",
    ]);
    setOrders(updatedList);
  };

  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "1rem",
      },
    },
  };

  const columns = [
    {
      name: "Date",
      selector: "date",
      sortable: true,
      format: (row) => `${toConvertDate(row.date)}`,
    },
    {
      name: "Référence",
      selector: "ref",
      sortable: true,
    },

    {
      name: "Utilisateur",
      selector: "createdBy",
      sortable: true,
    },

    {
      name: "Action",
      selector: "id",
      sortable: true,
      format: (row) => (
        <Tooltip title="Imprimer" color="#58c5cc" placement="leftTop">
          <Button
            type="link"
            onClick={(e) => printItem(row)}
            //onContextMenu={(e) => printBl(e)}
            icon={
              <img src="/images/print.svg" className="auto--icon-list"></img>
            }
          ></Button>
        </Tooltip>
      ),
    },
  ];

  const printItem = (id) => {
    setArticle(id);
    toPrintStock(id.id);
  };

  return (
    <div id="vente">
      <Loading show={show} color="red" showSpinner={true} />
      <Form layout="vertical">
        <Row className="auto--custom-header">
          <Col span="4">
            <Typography.Title level={5}>
              LISTE DES TRANSFERT STOCK
            </Typography.Title>
          </Col>
          <Col span="14"></Col>
          <Col span="3" style={{ textAlign: "right" }} justify="end">
            <Input.Search
              onInput={onSearch}
              value={searchValue}
              placeholder="Recherche par référence, client, total..."
              enterButton
            />
          </Col>
          <Col span="3" style={{ textAlign: "right" }}>
            <Link key="1" to="/transfert/creer">
              <Button
                type="link"
                size="large"
                icon={<img src="/images/plusVente.svg" />}
              ></Button>
            </Link>
          </Col>
        </Row>
      </Form>{" "}
      <Row>
        <Col span="24">
          <DataTable
            customStyles={customStyles}
            columns={columns}
            data={orders}
            pagination
            noHeader
            striped
            selectableRowsHighlight
            fixedHeader
            //onSelectedRowsChange={(e) => onSelectRow(e)}
            persistTableHead
            noDataComponent={<span>Pas de transfert trouvés</span>}
            contextMessage={{
              singular: "élément",
              plural: "éléments",
              message: "séléctionné(s)",
            }}
          />
        </Col>
      </Row>
      <div
        id="printable-content"
        style={{ position: "absolute", top: "-100%" }}
      >
        <table style={{ fontSize: "1rem" }}>
          <tr>
            <td style={{ fontSize: "1rem" }}>
              <b>Référence:</b>
            </td>{" "}
            <td style={{ fontSize: "1rem" }}>{article?.ref}</td>
          </tr>
          <tr>
            <td style={{ fontSize: "1rem" }}>
              <b>Article:</b>
            </td>{" "}
            <td style={{ fontSize: "1rem" }}>{article?.name}</td>
          </tr>
          <tr>
            <td style={{ fontSize: "1rem" }}>
              <b>Vendeur:</b>
            </td>{" "}
            <td style={{ fontSize: "1rem" }}>{article?.createdBy}</td>
          </tr>
          <tr>
            <td style={{ fontSize: "1rem" }}>
              <b>Emplacement source:</b>
            </td>{" "}
            <td style={{ fontSize: "1rem" }}>{article?.empSource}</td>
          </tr>
          <tr>
            <td style={{ fontSize: "1rem" }}>
              <b>Emplacement destination:</b>
            </td>{" "}
            <td style={{ fontSize: "1rem" }}>{article?.empDest}</td>
          </tr>
          <tr>
            <td style={{ fontSize: "1rem" }}>
              <b>Quantité:</b>
            </td>{" "}
            <td style={{ fontSize: "1rem" }}>{article?.qte}</td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default ListTransfert;
